import { GoogleLoginResponse } from '@/types/googleLoginResponse'
import { AuthenticationResult } from '@/types/authenticationResult'

type GoogleLoginHttp = (googleToken: string) => Promise<GoogleLoginResponse>
type RedirectToRetrieveToken = (authenticationResult: AuthenticationResult) => Promise<void>

export const googleLogin = (googleLoginHttp: GoogleLoginHttp, redirectToRetrieveToken: RedirectToRetrieveToken) =>
  async (googleToken: string, redirectUrlAfterLogin: string) => {
    const loginResponse = await googleLoginHttp(googleToken)
    await redirectToRetrieveToken(loginResponse.AuthenticationResult)
  }
